import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  paymentList: {
    status: StateStatus | null;
    data: any;
  };
  paymentInfoList: {
    status: StateStatus | null;
    data: any;
  };
  paymentInfoStatus: StateStatus | null | undefined;
  updatePaymentInfoReferenceStatus: StateStatus | null | undefined;
}

const initialState: IState = {
  paymentList: {
    status: null,
    data: null,
  },
  paymentInfoList: {
    status: null,
    data: null,
  },
  paymentInfoStatus: null,
  updatePaymentInfoReferenceStatus: null,
};

const PaymentListReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_PAYMENT_LIST:
      return {
        ...state,
        paymentList: {
          ...state.paymentList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.paymentList.data
              : action.data,
        },
      };
    case Types.SET_PAYMENT_INFO_LIST:
      return {
        ...state,
        paymentInfoList: {
          ...state.paymentInfoList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.paymentInfoList.data
              : action.data,
        },
      };
    case Types.PAYMENT_INFO:
      return {
        ...state,
        paymentInfoStatus: action.status,
      };
    case Types.UPDATE_PAYMENT_INFO_REFERENCE:
      return {
        ...state,
        updatePaymentInfoReferenceStatus: action.status,
      };
    default:
      return {
        ...state,
      };
  }
};

export default PaymentListReducer;
